import { render, staticRenderFns } from "./zDialogoPergunta.vue?vue&type=template&id=74d56000&scoped=true&"
import script from "./zDialogoPergunta.vue?vue&type=script&lang=js&"
export * from "./zDialogoPergunta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d56000",
  null
  
)

export default component.exports